import axios from 'axios'
import {ID} from '../../../../_metronic/helpers'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/forgot_password`

export type LoginParams = {
  email: string
  password: string
  business_id?: ID
  token?: string
}
// Server should return AuthModel
export async function login(data: LoginParams) {
  const res = (await axios.post(LOGIN_URL, data)) as AuthModel
  return res
}

export const refreshToken = async (refresh_token: string) =>
  (await axios.post(API_URL + '/auth/refresh_token', {refresh_token})) as AuthModel

// const refreshToken = () =>
// export async function refreshToken(refresh_token: string) {
//   return await axios.post<AuthModel>(API_URL + '/refresh_token', {
//     refresh_token,
//   })
// }

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string, reset_key?: number, password?: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
    reset_key,
    password,
  })
}

export async function getUserByToken() {
  const res = (await axios.get(GET_USER_BY_ACCESSTOKEN_URL)) as UserModel
  return res
}
